import React, { useEffect, useRef, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import "../../../assets/css/gcstudent/whatweoffer/WhatWeOffer.css";

const offerings = [
  {
    id: 1,
    title: "Physical Library",
    description: "Browse and reserve physical books from our extensive collection.",
    icon: (
      <svg width="26" height="26" viewBox="0 0 24 24" fill="none">
        <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20" stroke="currentColor" strokeWidth="1.8"/>
        <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z" stroke="currentColor" strokeWidth="1.8"/>
      </svg>
    ),
  },
  {
    id: 2,
    title: "Digital Library",
    description: "Access PDFs and e-books anytime, anywhere.",
    icon: (
      <svg width="26" height="26" viewBox="0 0 24 24" fill="none">
        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" stroke="currentColor" strokeWidth="1.8"/>
      </svg>
    ),
  },
  {
    id: 3,
    title: "Note Sharing",
    description: "Upload and download study notes easily.",
    icon: (
      <svg width="26" height="26" viewBox="0 0 24 24" fill="none">
        <circle cx="9" cy="7" r="4" stroke="currentColor" strokeWidth="1.8"/>
        <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" stroke="currentColor" strokeWidth="1.8"/>
      </svg>
    ),
  },
];

const WhatWeOffer = () => {
  const [active, setActive] = useState(null);
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        setIsVisible(true);
        observer.disconnect();
      }
    }, { threshold: 0.2 });

    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section className="gcStudent-offer-section" ref={sectionRef}>

      {/* BACKGROUND CIRCLES (FULL BACKGROUND LAYER) */}
      <div className="gcStudent-offer-bg">
        <span className="circle c1"></span>
        <span className="circle c2"></span>
        <span className="circle c3"></span>
        <span className="circle c4"></span>
      </div>

      <Container>

        <div className={`gcStudent-offer-header ${isVisible ? "gcStudent-offer-header--visible" : ""}`}>
          <h2 className="gcStudent-offer-title">What We Offer</h2>
          <p className="gcStudent-offer-subtitle">
            Everything you need for your academic journey in one place
          </p>
        </div>

        <Row className="gcStudent-offer-row justify-content-center">

          {offerings.map((item, index) => (
            <Col key={item.id} xs={12} md={4}>

              <div
                className={`gcStudent-offer-card 
                ${isVisible ? "gcStudent-offer-card--visible" : ""}
                ${active === item.id ? "gcStudent-offer-card--active" : ""}
                `}
                onClick={() => setActive(active === item.id ? null : item.id)}
                style={{ animationDelay: `${index * 0.15}s` }}
              >

                <div className="gcStudent-offer-icon-box">
                  {item.icon}
                </div>

                <h5>{item.title}</h5>
                <p>{item.description}</p>

              </div>

            </Col>
          ))}

        </Row>

      </Container>
    </section>
  );
};

export default WhatWeOffer;